// List of keys used in local storage.
export type LocalStorageKeys = "whats_new_count";

/**
 * A class to manage site wide local storage. The class is exported as a singleton.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
 */
export class LocalStorageManager {
    readonly isLocalStorageAvailable = typeof localStorage !== "undefined";

    private dispatchStorageEvent = () => {
        if (this.isLocalStorageAvailable && typeof window !== "undefined") {
            window.dispatchEvent(new Event("storage"));
        }
    };

    readonly getItem = (key: LocalStorageKeys) => (this.isLocalStorageAvailable ? localStorage.getItem(key) : null);

    readonly setItem = (key: LocalStorageKeys, value: string) => {
        if (this.isLocalStorageAvailable) {
            localStorage.setItem(key, value);
        }
        this.dispatchStorageEvent();
    };

    readonly removeItem = (key: LocalStorageKeys) => {
        if (this.isLocalStorageAvailable) {
            localStorage.removeItem(key);
        }
        this.dispatchStorageEvent();
    };

    readonly clear = () => {
        if (this.isLocalStorageAvailable) {
            localStorage.clear();
        }
        this.dispatchStorageEvent();
    };
}

export const localStorageManager = new LocalStorageManager();
